import FlourishDeck from "./FlourishDeck";

const NetworkRailProposal = () => <FlourishDeck partner="networkrail" />;

export default NetworkRailProposal;